import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { StarIcon } from '@heroicons/react/24/solid'



const testimonials = [
  {
    name: 'Sarah Johnson',
    role: 'Teen Student',
    rating: 5,
    text: 'Amazing experience! My instructor was patient and professional. Passed my road test on the first try!',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=face',
  },
  {
    name: 'Michael Chen',
    role: 'Adult Learner',
    rating: 5,
    text: 'As an adult learner, I was nervous to start. The team made me feel comfortable and confident behind the wheel.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
  },
  {
    name: 'Emily Rodriguez',
    role: 'Parent',
    rating: 5,
    text: 'My daughter completed the teen program and is now a confident, safe driver. Highly recommend to all parents!',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
  },
]

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
}

const cardVariants = {
  hidden: { opacity: 0, x: -30 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.6,
    },
  },
}

export default function Testimonials() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="text-accent font-heading font-semibold text-sm uppercase tracking-wider mb-2">
            Testimonials
          </div>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-4">
            What Our Students Say
          </h2>
          <p className="text-lg text-secondary-text max-w-2xl mx-auto">
            Don&apos;t just take our word for it - hear from our successful graduates.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8"
        >
          {testimonials.map((testimonial) => (
            <motion.div
              key={testimonial.name}
              variants={cardVariants}
              whileHover={{ y: -5, transition: { duration: 0.2 } }}
              className="bg-white p-6 rounded-lg shadow-soft"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <StarIcon key={i} className="w-5 h-5 text-accent" />
                ))}
              </div>
              <p className="text-secondary-text mb-6 italic">
                &quot;{testimonial.text}&quot;
              </p>
              <div className="flex items-center gap-3">
                <div className="relative w-12 h-12 rounded-full overflow-hidden">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="font-heading font-semibold text-primary">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-secondary-text">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* View All Link */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <Link
            to="/reviews"
            className="text-primary font-heading font-semibold hover:text-accent transition-colors inline-flex items-center gap-1"
          >
            View All Reviews <span>&gt;</span>
          </Link>
        </motion.div>
      </div>
    </section>
  )
}

